export class MigrationEventPayload {
	id: string;
	login: string;
	name: string;
	email: string;
	registered: boolean;
	migrated: boolean;

	constructor(id: string, login: string, name: string, email: string, registered: boolean, migrated: boolean = false) {
		this.id = id;
		this.login = login;
		this.name = name;
		this.email = email;
		this.registered = registered;
		this.migrated = migrated;
	}
}

export declare type MigrationMetadata = NetClientCSMetadata | TaxCompetitorMetadata;

export class NetClientCSMetadata {
	netfirmToken?: string;

	constructor(netfirmToken?: string) {
		this.netfirmToken = netfirmToken;
	}
}

export interface TaxCompetitorMetadata {
	competitorDescription: string;
	competitorCode: string;
	taxYear: number;
}

export interface MigrationEvent {
	companyId: string;
	description: string;
	migrationSource: string;
	initiatorContactId: string;
	notificationRecipients: Array<string>;
	bluemoonUserId: string;
	metadata?: MigrationMetadata;
	payload?: {
		clientsInfo?: Array<MigrationEventPayload>;
	};
	provisionTempStorage: boolean;
}
